/**
 * 用户相关
 */
import axios from '../axios';
// 登录
export function login(data = {}) {
    return axios({
        method: 'post',
        url: '/identity/login.do',
        data: { ...data },
    })
}
// 退出
export function logout(params = {}) {
  return axios({
      method: 'post',
      url: '/identity/logout.do',
      data: { ...params },
  })
}
// 认证登录
export function authLogin() {
    return axios({
        method: 'post',
        url: '/authLogin',
    })
}
// 第三方登录
export function thirdSsoLogin(params = {}) {
    return axios({
        method: 'post',
        url: '/thirdSsoLogin',
        data: { ...params },
    })
}
// 获取诚信监管ip
export function getConfig() {
    return axios({
        method: 'get',
        url: '/dict/system/config',
    })
}
// 获取字典表
export function dictionaries() {
    return axios({
        method: 'get',
        url: '/dict/dictionaries',
    })
}
// 获取全国省市
export function gerAreas() {
    return axios({
        method: 'get',
        url: '/dict/areas',
    })
}
//获取全国
export function getCountiesAll() {
    return axios({
      method: 'get',
      url: '/dict/nationwide',
  
    });
  
  }
// 获取行政区树菜单
export function getCounties(areaCode) {
    return axios({
        method: 'get',
        url: `/dict/counties?areaCode=${areaCode}`,
    })
}
// 获取广东的所有市级别
export function gerArea(params = {}) {
    return axios({
        method: 'get',
        url: '/dict/area',
        params: {
            ...params
        }
    })
}
// 获取行政区 广东省和市级别
export function gerCitys(params = {}) {
    return axios({
        method: 'get',
        url: '/dict/citys',
        params: {
            ...params
        }
    })
}
// 获取菜单
export function getMenus() {
    return axios({
        method: 'get',
        url: '/user/menus',
    })
}
// 下载文件 oss
export function downloadById(id) {
    return axios({
        method: 'get',
        url: `/fastdfs/downloadById/${id}`,
        responseType: 'arraybuffer',
    });
}
// 下载文件 oss
export function fastdfsDelete(id) {
    return axios({
        method: 'get',
        url: `/fastdfs/delete?id=${id}`,
    });
}
